
import { types } from './constants';

const mergeApiIntoBundle = (bundleDetailsData, apiResponse, isAuthenticated) => {
	if (!bundleDetailsData || !Array.isArray(bundleDetailsData.apis) || !apiResponse) {
		return bundleDetailsData;
	}

	const apiId = apiResponse.id;
	if (!apiId) return bundleDetailsData;

	const mergedApis = bundleDetailsData.apis.map(api => {
		if (!api || api.id !== apiId) return api;
		// Preserve existing minimal bundle fields (like `type`) but allow
		// full API details response (environments, plans, etc.) to override.
		let apiRes = apiResponse;
		if(!isAuthenticated) {
			const flatInstances = apiResponse.environments?.reduce((acc, env) => {
				if (Array.isArray(env.instances)) {
					acc.push(...env.instances);
				}
				return acc;
			}, []) || [];

			apiRes = {
				...apiResponse,
				instances: flatInstances
			};
		}
		return {
			...api,
			...apiRes,
			// Ensure `type` stays aligned with what bundle APIs use.
			type: api.type || apiResponse.type
		};
	});

	return {
		...bundleDetailsData,
		apis: mergedApis,
		oneToOneApiAnon: isAuthenticated === false,
	};
};

export default function reducer(state, action) {
	switch (action.type) {
		case types.BUNDLE_DETAILS_GET_REQUEST:
			return {
				...state,
				apiInfo: {
					...state.apiInfo,
					isFetching: true,
					error: ''
				},
				bundleDetails: {
					...state.bundleDetails,
					isFetching: true,
					error: ''
				}
			};

		case types.BUNDLE_DETAILS_GET_RECEIVE: {
			const data = action.response;
			return {
				...state,
				apiInfo: {
					data,
					isFetching: false,
					error: ''
				},
				bundleDetails: {
					data,
					isFetching: false,
					error: ''
				}
			};
		}

		case types.BUNDLE_DETAILS_GET_ERROR:
			return {
				...state,
				apiInfo: {
					...state.apiInfo,
					isFetching: false,
					error: action.error || 'Failed to fetch bundle details'
				},
				bundleDetails: {
					...state.bundleDetails,
					isFetching: false,
					error: action.error || 'Failed to fetch bundle details'
				}
			};


		case types.API_SPEC_IN_BUNDLE_GET_REQUEST:
			return {
				...state,
				apiSpecInBundle: {
					isFetching: true,
					error: ''
				}
			};

		case types.API_SPEC_IN_BUNDLE_GET_RECEIVE: {
			const mergedBundle = mergeApiIntoBundle(
				state.bundleDetails?.data,
				action.response,
				action?.args?.isAuthenticated,
			);

			return {
				...state,
				apiSpecInBundle: {
					isFetching: false,
					error: ''
				},
				bundleDetails: {
					...state.bundleDetails,
					data: mergedBundle
				},
				apiInfo:
					state.apiInfo?.data && state.apiInfo.data.id === state.bundleDetails?.data?.id
						? {
								...state.apiInfo,
								data: mergedBundle,
								oneToOneApiAnon: action?.args?.isAuthenticated === false
						  }
						: state.apiInfo
			};
		}

		case types.API_SPEC_IN_BUNDLE_GET_ERROR:
			return {
				...state,
				apiSpecInBundle: {
					isFetching: false,
					error: action.error || 'Failed to fetch API spec in bundle'
				}
			};

		default:
			return state;
	}
}

